import * as AvatarPrimitive from '@radix-ui/react-avatar';
import classNames from 'classnames';
import { FileX, User } from 'lucide-react';
import { Icon, type IconProps } from '../Icon';
import * as styles from './index.css';

type AvatarProps = AvatarPrimitive.AvatarProps & {
    imgSrc?: string;
    imgAlt?: string;
    size?: 's' | 'm' | 'l' | 'xl';
    mode?: 'system' | 'client';
};

const iconSize: Record<NonNullable<AvatarProps['size']>, NonNullable<IconProps>['size']> = {
    s: 'sm',
    m: 'md',
    l: 'lg',
    xl: '5xl',
};

export function Avatar({ imgSrc, imgAlt = '', size = 'm', className, mode = 'system', ...props }: AvatarProps) {
    const rootClassNames = classNames(styles.root, styles.size[size], className);

    if (!imgSrc) {
        return (
            <AvatarPrimitive.Root
                className={classNames(styles.root, styles.placeholder[mode], styles.size[size], className)}
                {...props}
            >
                <Icon icon={User} size={iconSize[size]} />
            </AvatarPrimitive.Root>
        );
    }

    return (
        <AvatarPrimitive.Root className={rootClassNames} {...props}>
            <AvatarPrimitive.Image src={imgSrc} alt={imgAlt} className={styles.image} />
            <AvatarPrimitive.Fallback className={styles.fallback} delayMs={300}>
                {/* TODO: Add a proper fallback icon */}
                <Icon icon={FileX} size={iconSize[size]} />
            </AvatarPrimitive.Fallback>
        </AvatarPrimitive.Root>
    );
}
